import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { DisplayOrderCompletionState } from './work-orders/work-order'

@Directive({
  selector: '[appOrderCompletionStateSelect]',
})
export class OrderCompletionStateSelectDirective {
  private select = inject(ElderSelectComponent)
  readonly enumTranslationService = inject(ElderEnumTranslationService)

  constructor() {
    const enumTranslationService = this.enumTranslationService

    this.select.displayProperty = 'displayValue'
    this.select.nullDisplay = 'context.noSelection'
    this.select.dataSource = enumTranslationService.enumDataSource(
      DisplayOrderCompletionState,
      'work_order_completion_state' // TODO: naming?
    )
  }
}
